
 <div class="col-sm-12">
<h2>Application For LCSA Tax Credit Determination</h2>
</div>
<div class="col-sm-12 well"  *ngIf="!success" >
<div class="row col-sm-12 mt-3">
    <p class="text-justify">
      Under Public Act 50 of 2002, section 13b(5), tax credits are afforded to telecommunication providers that invest in new broadband
      infrastructure. The MPSC must certify documentation that providers have paid the right-of-way fees to the Local Community
      Stabilization Authority (formerly METRO Authority) per Section 8(14) of Public Act 48.  </p>
      <p class="text-justify">
      This online process will assist the provider in accomplishing that requirement. Each provider must complete the entire process.
      Do not leave any portion blank. <!-- If you have any questions relating to this form, please call or email Sean Kelly at
      517-284-8210 or kellys1@michigan.gov. -->

      Please fill out a seperate form for each of your companies. Do not combine companies.
    </p>

    <p class="text-justify" style="font-size:125%;font-weight:bold;"><span *ngIf="!isFormEnabled">Applications are not currently being accepted.</span> The application window opens on May 1st.
      If you have questions relating to this form, please contact Sean Kelly at 517-284-8210 or <a href="mailto:kellys1@michigan.gov"><strong>kellys1@michigan.gov</strong></a>.</p>
</div>
<br />

  <div class="row col-sm-12">
    <div class="form-group col-sm-6">
      <label for="company-name" class="control-label required">Company Name</label>
      <input type="text" trim="blur" class="form-control" id="company-name" [formControl]="taxForm.controls['companyName']" [(ngModel)]="taxData.companyName"
        placeholder="Enter your Company name" required name="companyName">
      <div *ngIf="(taxForm?.controls['companyName']?.errors?.required || taxForm?.controls['companyName']?.errors?.isValid) && taxForm?.controls['companyName']?.touched" class="error-msg">
        Company Name is Required!
      </div>
    </div>

    <div class="form-group col-sm-6">
      <label for="person-name" class="control-label required">Name of person filling out this form</label>
      <input type="text" trim="blur" class="form-control" id="person-name" [formControl]="taxForm.controls['personName']" [(ngModel)]="taxData.personName"
        placeholder="Enter Person filling out the form" required name="personName">
      <div *ngIf="(taxForm?.controls['personName']?.errors?.required || taxForm?.controls['personName']?.errors?.isValid) && taxForm?.controls['personName']?.touched" class="error-msg">
        Person Name is Required!
      </div>
    </div>
  </div>

  <div class="row col-sm-12">
    <div class="form-group col-sm-6">
      <label for="invoiceNumber" class="control-label required">Invoice Number from the LCSA bill</label>
      <input type="text" trim="blur" class="form-control" id="invoiceNumber" [formControl]="taxForm.controls['invoiceNumber']" [(ngModel)]="taxData.invoiceNumber"
        placeholder="Enter Invoice Number from LCSA bill" required name="invoiceNumber">
      <div *ngIf="(taxForm?.controls['invoiceNumber']?.errors?.required || taxForm?.controls['invoiceNumber']?.errors?.isValid) && taxForm?.controls['invoiceNumber']?.touched" class="error-msg">
        Invoice Number is Required!
      </div>
    </div>

    <div class="form-group col-sm-6">
      <label for="amountBilledLcsa" class="control-label required">Amount billed by the LCSA</label>
      <input type="text" currencyMask class="form-control" id="amountBilledLcsa" [formControl]="taxForm.controls['amountBilledLcsa']" [(ngModel)]="taxData.amountBilledLcsa"
        placeholder="Enter Amount billed by LCSA" required name="amountBilledLcsa">
      <div *ngIf="(taxForm?.controls['amountBilledLcsa']?.errors?.required ) && taxForm?.controls['amountBilledLcsa']?.touched" class="error-msg">
        Amount billed by LCSA is Required!
      </div>
        <!-- <div *ngIf="taxData.amountBilledLcsa !='undefined' && taxData.amountBilledLcsa != null && taxData.amountBilledLcsa != '' && taxForm?.controls['amountBilledLcsa']?.errors?.numeric && taxForm?.controls['amountBilledLcsa']?.touched" class="error-msg">
        Amount billed by LCSA must be a number!
      </div> -->

    </div>
  </div>

  <div class="row col-sm-12">
    <div class="form-group col-sm-6">
      <label for="amountPaidLcsa" class="control-label required">Amount paid to the LCSA</label>
      <input type="text" currencyMask class="form-control" id="amountPaidLcsa" [formControl]="taxForm.controls['amountPaidLcsa']"  [(ngModel)]="taxData.amountPaidLcsa"
        placeholder="Enter Amount Paid to LCSA" required name="amountPaidLcsa">
      <div *ngIf="(taxForm?.controls['amountPaidLcsa']?.errors?.required ) && taxForm?.controls['amountPaidLcsa']?.touched" class="error-msg">
        Amount Paid LCSA is Required!
      </div>
      <!-- <div *ngIf="taxData.amountPaidLcsa !='undefined' && taxData.amountPaidLcsa != null && taxData.amountPaidLcsa != '' && taxForm?.controls['amountPaidLcsa']?.errors?.numeric && taxForm?.controls['amountPaidLcsa']?.touched" class="error-msg">
        Amount Paid LCSA must be a number!
      </div> -->
    </div>

    <div class="form-group col-sm-6">
      <label for="datePaid" class="control-label required">Date Paid</label>
      <input type="date" validDateOrNull class="form-control" id="datePaid" [formControl]="taxForm.controls['datePaid']" [(ngModel)]="taxData.datePaid"
        placeholder="MM/DD/YYYY" required name="personName" max="9999-12-31">
      <div *ngIf="(taxForm?.controls['datePaid']?.errors?.required || taxForm?.controls['datePaid']?.errors?.isValid) && taxForm?.controls['datePaid']?.touched" class="error-msg">
        Date Paid is Required!
      </div>
    </div>
  </div>

  <div class="row col-sm-12">
    <div class="form-group col-sm-6">
      <label for="emailAddress" class="control-label required"> Your Email Address</label>
      <input type="text" class="form-control" id="emailAddress" [formControl]="taxForm.controls['emailAddress']" [(ngModel)]="taxData.emailAddress"
        placeholder="Enter your Email Address" required name="emailAddress">
      <div *ngIf="(taxForm?.controls['emailAddress']?.errors?.required ) && taxForm?.controls['emailAddress']?.touched" class="error-msg">
        Email Address is Required!
      </div>
      <div *ngIf="taxData.emailAddress !='undefined' && taxData.emailAddress != null && taxData.emailAddress != '' && taxForm?.controls['emailAddress']?.errors?.email && taxForm?.controls['emailAddress']?.touched" class="error-msg">
        Please enter valid email address!
      </div>

    </div>

    <div class="form-group col-sm-6">
      <label for="phoneNumber" class="control-label required">Phone Number </label>
      <input type="text" [mask]="mask"  class="form-control" id="phoneNumber" [formControl]="taxForm.controls['phoneNumber']" [(ngModel)]="taxData.phoneNumber"
        placeholder="Enter Phone Number"  required name="personName">
      <div *ngIf="(taxForm?.controls['phoneNumber']?.errors?.required || taxForm?.controls['phoneNumber']?.errors?.isValid) && taxForm?.controls['phoneNumber']?.touched" class="error-msg">
        Phone Number is Required!
      </div>
      <div *ngIf="taxData.phoneNumber !='undefined' && taxData.phoneNumber != null && taxData.phoneNumber != '' && taxForm?.controls['phoneNumber']?.errors?.invalidPhone && taxForm?.controls['phoneNumber']?.touched" class="error-msg">
          Please enter a valid phone number!
        </div>
    </div>
  </div>




<div class="col-sm-12">
    <fieldset id="paidGroup">
        <legend class="form-check-label legend-hidden">9.Have you paid? </legend>
    <label id="paidLabel" class="control-label required">Have you paid?</label>

     <div *ngFor="let option of paidOptions; let i = index">
      <label for="paidOptions{{i}}">
        <input type="radio" (change)="resetQuestion9()" id="paidOptions{{i}}" name="paidGroup" [formControl]="taxForm.controls['paid']" [(ngModel)]="taxData.paid" [value]="option.value">
        {{option.display}}
        </label>
    </div>
    <!-- <textarea class="form-control" name="paidComments" [(ngModel)]="taxData.paidComments" id="comments" aria-label="paidComments" ></textarea> -->
    <input type="text" trim="blur"  [attr.disabled]="taxData.paid !== 'Other'? '' : null" class="form-control" id="paidComments" [formControl]="taxForm.controls['paidComments']" [(ngModel)]="taxData.paidComments" name="paidComments" aria-label="paidComments" >
    <div *ngIf="taxForm?.controls['paid']?.errors?.required && taxForm?.controls['paid']?.touched" class="error-msg">
        Have you paid is Required!
      </div>
      <div *ngIf="taxData.paid === 'Other'
      && (taxData.paidComments === '' || taxData.paidComments === 'undefined' || taxData.paidComments === null )"
        class="error-msg">
           This field is Required when other is checked!
       </div>
    </fieldset>
</div>

<div class="col-sm-12 mt-5">
  <p> As proof of payment, please email a copy of the current year’s electronic payment or both sides of canceled check(s) to:
    <a href="mailto:kellys1@michigan.gov"><strong>Sean Kelly</strong></a></p>
</div>
<div class="form-group col-sm-12 ">
    <fieldset id="question10Group">
        <legend class="form-check-label legend-hidden">10. </legend>

  <label id="question10Label" class="form-check-label required">
     Each ILEC/CLEC must also provide under Public Act 48 of 2002, section 8(14)(b), "Verification that the provider's rates and
      charges for basic local exchange service, including revenues from intrastate subscriber line or end-user line charges,
      do not exceed the commission's approved rates and charges for those services. I attest to this statement."
   </label>

    <div *ngFor="let option of radioBtnOptions; let i = index">
      <label for="question10{{i}}">
        <input type="radio" id="question10{{i}}" name="question10Group" [formControl]="taxForm.controls['question10']" [(ngModel)]="taxData.question10" [value]="option.value">
        {{option.display}}
        </label>
    </div>
  </fieldset>
 <div *ngIf="taxForm?.controls['question10']?.errors?.required && taxForm?.controls['question10']?.touched" class="error-msg">
       Attestation is Required!
      </div>


</div>
<div class="form-group col-sm-12">
    <fieldset id="question11Group">
        <legend class="form-check-label legend-hidden">11. </legend>
  <label id="question11Label" class="form-check-label required">
  This application is for:
  </label>

  <div *ngFor="let option of applicationOptions; let i = index">
      <label for="question11{{i}}">
        <input type="radio" (change)="resetQuestion11()" id="question11{{i}}" name="question11Group" [formControl]="taxForm.controls['question11']" [(ngModel)]="taxData.question11" [value]="option.value">
        {{option.display}}
        </label>
    </div>
    </fieldset>
  <input type="text" trim="blur" [attr.disabled]="taxData.question11 !== 'Other' ? '' : null" class="form-control" id="question11Comment" [formControl]="taxForm.controls['question11Comment']" [(ngModel)]="taxData.question11Comment" name="question11Comment" aria-label="question11Comment" >
  <div *ngIf="taxForm?.controls['question11']?.errors?.required && taxForm?.controls['question11']?.touched" class="error-msg">
    Application for is Required!
  </div>
  <div *ngIf="taxData.question11 === 'Other'
      && (taxData.question11Comment === '' || taxData.question11Comment === 'undefined' || taxData.question11Comment === null )"
        class="error-msg">
           This field is Required when other is checked!
       </div>
</div>

<div class="col-sm-12">
  <p> Please review the form before clicking submit. <strong> All fields are required.</strong> </p>
  <p> Please press submit only once. </p>

</div>

<div class="form-group col-sm-12 text-center">
    <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
  <button type="submit" (click)="save()" class="btn btn-primary offset1" [disabled]="!isFormEnabled" >Submit</button>
</div>

</div>


<div class ="container" *ngIf="success" >

    <div class="col-sm-12 mt-3">
    <strong class="col-sm-12 text-center">Application for METRO Act Tax Credit Determination</strong>
    <strong class="col-sm-12 text-center">a, thanks for your submittal.</strong>
    <strong class="col-sm-12 text-center">Please print a copy for your records.</strong>
   </div>
   <div class="col-sm-12 mt-5">
<table class="table table-striped table-bordered col-sm-12" role='presentation'>

  <tbody>
      <tr>
            <th class="col-sm-4">
            </th>
            <th class="col-sm-8">
            </th>
        </tr>
    <tr>
      <td>Company Name:</td>
      <td>{{taxData.companyName}}</td>
    </tr>
    <tr>
      <td>Name:</td>
      <td>{{taxData.personName}}</td>
    </tr>
    <tr>
      <td>Invoice Number:</td>
      <td>{{taxData.invoiceNumber}}</td>
    </tr>
     <tr>
      <td>Amount Billed:</td>
      <td>${{taxData.amountBilledLcsa}}</td>
    </tr>
    <tr>
      <td>Amount Paid:</td>
       <td>${{taxData.amountPaidLcsa}}</td>
    </tr>
   <tr>
      <td>Date Paid:</td>
       <td>{{taxData.datePaid}}</td>
    </tr>
    <tr>
      <td>E-Mail Address:</td>
       <td>{{taxData.emailAddress}}</td>
    </tr>
    <tr>
      <td>Phone Number:</td>
       <td>{{taxData.phoneNumber}}</td>
    </tr>
    <tr>
      <td>Other explain:</td>
       <td>{{taxData.paidComments}}</td>
    </tr>
     <tr>
      <td>Application is for:</td>
       <td>{{taxData.question11}}</td>
    </tr>
    <tr>
      <td>Explanation:</td>
       <td>{{taxData.question11Comment}}</td>
    </tr>
     <tr>
      <td>Date Submitted:</td>
      <td>{{today | date: 'MM/dd/yyyy'}}</td>
    </tr>
  </tbody>
</table>
  </div>

<div class="form-group col-sm-12 text-center">
    <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
    <button type="goBack" (click)="goBack()" class="btn btn-primary offset1">Back to Application for LCSA Tax Credit</button>
      </div>
   </div>
